export default __webpack_public_path__ + "static/media/huawei.fa8ca83d.mp4";